import { render, staticRenderFns } from "./block-info.vue?vue&type=template&id=1f1ae8fc&scoped=true&"
import script from "./block-info.vue?vue&type=script&lang=js&"
export * from "./block-info.vue?vue&type=script&lang=js&"
import style0 from "./block-info.vue?vue&type=style&index=0&id=1f1ae8fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f1ae8fc",
  null
  
)

component.options.__file = "block-info.vue"
export default component.exports